<div class="flex-row">
  <div class="flex-col-50 input-tooltip-row">
    <bricks-input-autocomplete
      [label]="'Hersteller der Turbine'"
      [placeholder]="'Bitte auswählen'"
      [isRequired]="true"
      [formControl]="resource().controls.turbineManufacturer"
      [options]="turbineManufacturersOptions()"
      [width]="'fill'" />
  </div>
  <div class="flex-col-50 input-tooltip-row">
    <bricks-input-dropdown
      [label]="'Turbinentyp'"
      [placeholder]="'Bitte auswählen'"
      [isRequired]="true"
      [formControl]="resource().controls.turbineType"
      [width]="'fill'">
      @for (turbine of turbineTypesOptions(); track turbine) {
        <bricks-option [value]="turbine">
          {{ turbine }}
        </bricks-option>
      }
    </bricks-input-dropdown>
  </div>
</div>

<div class="flex-col-49 input-tooltip-row">
  @let turbineHubHeight = resource().controls.turbineHubHeight;
  <bricks-input
    appDigitsOnly
    [allowComma]="true"
    appFormatView
    [focusInFormatter]="$any(ViewFormatterService.numberToStringFormatter)"
    [focusOutFormatter]="ViewFormatterService.numberToLocaleStringFormatter()"
    [changeFormatter]="ViewFormatterService.stringToNumberFormatter"
    [label]="'Nabenhöhe'"
    [placeholder]="'z. B. 30'"
    [isRequired]="true"
    [formControl]="turbineHubHeight"
    [width]="'fill'">
    <span text-suffix>m</span>
    @if (turbineHubHeight.errors) {
      <bricks-error>
        {{ getTurbineHubHeightError(turbineHubHeight) }}
      </bricks-error>
    }
  </bricks-input>
</div>
